export var noEmptySegmentValidator = function (value) {
    return value === null || value === void 0 ? void 0 : value.split('/').every(Boolean);
};
//# sourceMappingURL=no-empty-segment-validator.js.map